import io from 'socket.io-client';

const socketWpp = io(`${location.protocol}//${location.hostname}:4000`, {
  transports: ['websocket']
});

socketWpp.on('connect', () => {
  console.log('[socketWpp] conectado:', socketWpp.id);
});

export default socketWpp;